import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import OwButton from "../OwButton/OwButton";

type Props = {
    isOpen: boolean;
    /** Read-only context line shown above the textarea (screen + active filters) */
    context: string;
    translate: (id: string) => string;
    onSend: (text: string) => Promise<void> | void;
    onCancel: () => void;
};

/**
 * "Send a suggestion" dialog for the FilterBar drawer footer.
 */
export const FeedbackModal = (props: Props) => {
    const [text, setText] = useState("");
    const [sending, setSending] = useState(false);

    useEffect(() => {
        if (props.isOpen) {
            setText("");
            setSending(false);
        }
    }, [props.isOpen]);

    const send = async () => {
        if (!text.trim().length || sending) {
            return;
        }

        setSending(true);

        try {
            await props.onSend(text.trim());
        } finally {
            setSending(false);
        }
    };

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onCancel}
            className={"modalContentClass FilterBar-modal"}
            overlayClassName={"modalOverlayClass FilterBar-modal-overlay"}
            ariaHideApp={false}
            contentLabel={props.translate("send_a_suggestion")}>
            <div className={"p-3"}>
                <h5 className={"mb-2"}>{props.translate("send_a_suggestion")}</h5>
                <small className={"text-muted d-block mb-2"}>{props.context}</small>
                <textarea
                    id={"filter-bar-feedback"}
                    className={"form-control form-control-sm"}
                    rows={5}
                    autoFocus={true}
                    value={text}
                    maxLength={2000}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setText(e.target.value)}
                />
                <div className={"d-flex justify-content-end mt-3"}>
                    <OwButton title={"cancel"} className={"btn-secondary me-2"} fn={props.onCancel} disabled={sending} />
                    <OwButton
                        title={"send"}
                        className={"btn-warning"}
                        fn={send}
                        disabled={!text.trim().length}
                        active={sending}
                        disableOnActive={true}
                    />
                </div>
            </div>
        </Modal>
    );
};
